import {
  computePercent,
  deriveCompletedSections,
  getSectionsForCommunity,
  setStoredProfileCompletion,
  buildPartnershipQuestionCompletionOptions,
} from './profile-completion-sections'

function isComplete(percent) {
  return percent === 100
}

// Decide which sections are complete now (after the latest save) and persist
// the profile completion status in localStorage.
export default function syncProfileCompletion({
  partner,
  previousPartner,
  community,
  updatePartnerBadge,
  options = {},
}) {
  if (!community || !community.partnerProfileCompletionEnabled) {
    return Promise.resolve()
  }
  if (!partner) return Promise.resolve()

  const state =
    typeof window !== 'undefined' && window.store && window.store.getState
      ? window.store.getState()
      : null
  const mergedOptions = {
    ...(state ? buildPartnershipQuestionCompletionOptions(state) : {}),
    ...options,
  }

  const sections = getSectionsForCommunity(community)
  const completedSet = deriveCompletedSections(
    partner,
    community,
    mergedOptions
  ).filter((sectionKey) => sections.includes(sectionKey))
  const percent = computePercent(completedSet.length, sections.length)

  setStoredProfileCompletion(partner.id, {
    sectionsCompleted: completedSet,
    percentCompletion: percent,
  })
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('profile-completion-updated'))
  }

  const previousCompletedCount = previousPartner
    ? deriveCompletedSections(previousPartner, community, mergedOptions).filter(
        (sectionKey) => sections.includes(sectionKey)
      ).length
    : completedSet.length
  const previousPercent = computePercent(
    previousCompletedCount,
    sections.length
  )
  const didCompletionStateChange =
    isComplete(previousPercent) !== isComplete(percent)

  if (didCompletionStateChange && typeof updatePartnerBadge === 'function') {
    return Promise.resolve(
      updatePartnerBadge({
        orgProfile: isComplete(percent),
      })
    ).catch(() => Promise.resolve())
  }

  return Promise.resolve()
}
